module.exports = __webpack_public_path__ + "img/smile.1ede85d0.svg";